
(function() {
  const originalFetch = window.fetch;
  let cartRequestCount = 0;
  const CART_LIMIT = 15;

  window.fetch = function(...args) {
    const url = args[0];
    if (typeof url === "string" && url.includes("/cart.js")) {
      cartRequestCount++;
      if (cartRequestCount > CART_LIMIT) {
        return Promise.reject(new Error("Cart request limit reached"));
      }
    }

    return originalFetch.apply(this, args);
  };
    
})();

(function() {
  const originalOpen = XMLHttpRequest.prototype.open;
  let cartRequestCount = 0;
  const CART_LIMIT = 10;

  XMLHttpRequest.prototype.open = function(method, url, ...rest) {
    if (url.includes("/cart.js")) {
      cartRequestCount++;
      if (cartRequestCount > CART_LIMIT) {
        this.abort();
        return;
      }
    }
    return originalOpen.apply(this, [method, url, ...rest]);
  };
})();